// ModalContext.tsx
import { createContext, useContext, useEffect, useState } from 'react';
import { modalController } from '../../../Helpers/modalController';
import ModalPopup from '../Common/ModalPopup';
import Addbutton from '../Elements/Addbutton';
import loadJsonDelete from '../Utils/jsonDelete';
import loadJsonPost from '../Utils/jsonPost';
import loadJsonPut from '../Utils/jsonPut';
import { formatDate, formatedToInput } from 'Helpers/dateHelper';
import Select from 'react-select';

const ModalContext = createContext(null as any);

export function ModalProvider({ children }) {
    const [params, setParams] = useState<any[]>([]);
    const [type, setType] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [extraInfo, setExtraInfo] = useState<any>(null);
    useEffect(() => {
        modalController.register(showAdditionalParams);
    }, []);

    /*
        type = 0: error
        type = 1: show additional params
    */
    const showAdditionalParams = (params: any[], type = 0, extraInfo: any, resolve: (input: any) => void) => {
        setType(type);
        setParams(params);
        setExtraInfo({ ...extraInfo, resolve });
        setIsOpen(true);
    };
    function onclickHandler() {
        switch (extraInfo.method) {
            case 'DELETE':
                loadJsonDelete(extraInfo.url + getParamsAsString()).then(data => {
                    setIsOpen(false);
                    extraInfo.resolve?.(data);
                });
                break;
            case 'POST':
                loadJsonPost(extraInfo.url + getParamsAsString(), extraInfo.sendData).then(data => {
                    setIsOpen(false);
                    extraInfo.resolve?.(data);
                });
                break;
            case 'PUT':
                loadJsonPut(extraInfo.url + getParamsAsString(), extraInfo.sendData).then(data => {
                    setIsOpen(false);
                    extraInfo.resolve?.(data);
                });
                break;
        }
    }
    function getParamsAsString() {
        let paramsString = extraInfo.url.includes('?') ? '&' : '?';
        params.forEach(param => {
            if (param.Value) {
                paramsString += param.RequestParameter + '=' + param.Value + '&';
            }
            if (param.ParameterType === 9) {
                paramsString += param.RequestParameter + '=' + param.Name + '&';
            }
        });
        return paramsString;
    }

    function onChangeHandler(index: number, value: any) {
        setParams(prev => {
            prev[index].Value = value;
            return [...prev];
        });
    }
    return (
        <ModalContext.Provider value={{ showAdditionalParams }}>
            {children}
            {isOpen && type === 1 && (
                <ModalPopup modalClass="mfx-add-modal">
                    <div className="mfx-action-buttons">
                        <Addbutton
                            disableChangeHandler={() => {
                                extraInfo.resolve?.(null);
                                setIsOpen(false);
                            }}
                            disableMode={true}
                            save={false}
                        />
                    </div>
                    <h1>{extraInfo.meta?.ErrorMessages?.[0]?.Message ?? window.Dictionary.getTranslation(17275)}</h1>
                    <div className="mfx-add-modal-content">
                        {params.map((param, index) => (
                            <>
                                {param.ParameterType !== 9 && (
                                    <div key={index} className="mfx-add-modal-item">
                                        {param.ParameterType !== 2 && <label>{window.Dictionary.getTranslation(param.DllNr ?? param.Name)}</label>}
                                        {param.ParameterType === 6 && (
                                            <div className="mfx-dropdown">
                                                <div className="mfx-react-select">
                                                    <Select
                                                        maxMenuHeight={150}
                                                        menuPosition={'fixed'}
                                                        id={'modal-context-' + param.Name}
                                                        name={param.RequestParameter}
                                                        onChange={(e: any) => onChangeHandler(index, e.value)}
                                                        options={Object.entries(param.SelectableValues).map(option => {
                                                            return { label: option[1], value: option[1] };
                                                        })}
                                                        //defaultValue={props.customerData ? {label: props.customerData, value: props.customerData} : defaultData}
                                                        value={{ label: param.Value, value: param.Value }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {(param.ParameterType === 0 || param.ParameterType === 1 || param.ParameterType === 8) && <input required={true} id={'modal-context-' + param.Name} type="text" value={param.Value} onChange={e => onChangeHandler(index, e.target.value)} />}
                                        {(param.ParameterType === 3 || param.ParameterType === 4) && (
                                            <input id={'modal-context-' + param.Name} type="number" value={isNaN(param.Value?.replace(',', '.')) ? null : param.Value?.replace(',', '.')} onChange={e => onChangeHandler(index, e.target.value)} />
                                        )}
                                        {(param.ParameterType === 5 || param.ParameterType === 7) && <input id={'modal-context-' + param.Name} type="date" value={formatedToInput(param.Value,'Date')} onChange={e => onChangeHandler(index, formatDate(new Date(e.target.value)))} />}
                                        {param.ParameterType === 2 && (
                                            <div className="mfx-checkbox-element">
                                                <input
                                                    id={'modal-context-' + param.Name}
                                                    type="checkbox"
                                                    checked={param.Value === 'TRUE' ? true : false}
                                                    onChange={e => {
                                                        onChangeHandler(index, e.target.checked ? 'TRUE' : 'FALSE');
                                                    }}
                                                />
                                                <label>{window.Dictionary.getTranslation(param.DllNr ?? param.Name)}</label>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                    <br></br>
                    <button type="submit" id="button-create" className="send-button button center" onClick={() => onclickHandler()}>
                        {window.Dictionary.getTranslation(4765)}
                    </button>
                </ModalPopup>
            )}
        </ModalContext.Provider>
    );
}

export function useModal() {
    return useContext(ModalContext);
}
